import React from "react";
import Marquee from "react-fast-marquee";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import NavBar from "./Component/NavBar";
import { Notification_Content } from './Component/Notification_Content'
const Notifications = () => {

    return (
        <>
            <Header />
            <div className="w-100">
                <NavBar />
                <div className="row">
                    <div className="col text-center">
                        <div className="TabTitle text-center mt-4">
                            <b className="my_title fs-3">Notifications</b>
                        </div>
                    </div>
                </div>
                <div
      style={{
        width: '90%',
        whiteSpace: 'nowrap',
        marginLeft:"20px",
        fontSize:"30px"
      }}
    >
      {
        Notification_Content.map((data)=>(
     <Marquee style={{color:"blue"}} className="p-3" key={data.id}>
       {data.Messege}
      </Marquee>
        ))
      }  
      
    </div>
            </div>
            <Footer />
        </>
    );
};
export default Notifications;